import React from 'react';
import ReactDOM from 'react-dom';
import { LawFirmApp } from './LawFirmApp';
import { CustomWindow } from './lawFirm.types';

declare let window: CustomWindow;

const target = document.querySelector(`[data-react=doctrine-react]`);
if (target) {
  ReactDOM.render(<LawFirmApp readKey={window.read_key} />, target);
} else {
  // eslint-disable-next-line no-console
  console.log(`doctrine-react is not visible in the DOM`);
}
